import React from 'react';

const CourseIntroduction = () => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
        <h1 className="text-3xl font-bold text-center text-[rgb(130,88,18)] mb-6">
          Welcome to Intellectual Oasis Learning Platform
        </h1>
        
        <p className="text-gray-700 mb-8">
          Intellectual Oasis is your gateway to professional development and continuous learning. Our platform offers a diverse range of courses designed to enhance your skills and knowledge in various fields.
        </p>

        <h2 className="text-2xl font-semibold text-[rgb(130,88,18)] mb-4 mt-8">
          Getting Started
        </h2>
        <div className="space-y-4">
          <div className="flex items-start space-x-4">
            <div className="text-[rgb(130,88,18)]">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
            </div>
            <div>
              <h3 className="font-semibold text-lg">Browse Courses</h3>
              <p className="text-gray-600">Explore our catalog of certification and recommended courses across various categories including Arts, Business, IT, and more.</p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <div className="text-[rgb(130,88,18)]">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
            </div>
            <div>
              <h3 className="font-semibold text-lg">Enroll in Courses</h3>
              <p className="text-gray-600">Select courses that interest you and enroll to begin your learning journey. Track your progress as you complete modules and assessments.</p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <div className="text-[rgb(130,88,18)]">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <div>
              <h3 className="font-semibold text-lg">Track Progress</h3>
              <p className="text-gray-600">Monitor your learning journey through our intuitive progress tracking system. Complete modules and assessments to advance.</p>
            </div>
          </div>
        </div>

        <hr className="my-8 border-gray-200" />

        <h2 className="text-2xl font-semibold text-[rgb(130,88,18)] mb-4">
          Course Structure
        </h2>
        <div className="space-y-4">
          <div className="flex items-start space-x-4">
            <div className="text-[rgb(130,88,18)]">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <div>
              <h3 className="font-semibold text-lg">Course Modules</h3>
              <p className="text-gray-600">Each course is divided into modules containing sub-courses. Complete all required content and assessments to progress.</p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <div className="text-[rgb(130,88,18)]">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <h3 className="font-semibold text-lg">Assessments</h3>
              <p className="text-gray-600">Regular assessments help reinforce your learning. Complete these to demonstrate your understanding of the course material.</p>
            </div>
          </div>
        </div>

        <hr className="my-8 border-gray-200" />

        <h2 className="text-2xl font-semibold text-[rgb(130,88,18)] mb-4">
          Certification Process
        </h2>
        <div className="space-y-4">
          <div className="flex items-start space-x-4">
            <div className="text-[rgb(130,88,18)]">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
              </svg>
            </div>
            <div>
              <h3 className="font-semibold text-lg">Earning Certificates</h3>
              <p className="text-gray-600">Complete all course requirements, including modules and assessments, to earn your certificate. Certificates are automatically generated upon completion.</p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <div className="text-[rgb(130,88,18)]">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <div>
              <h3 className="font-semibold text-lg">Certificate Verification</h3>
              <p className="text-gray-600">All certificates come with a unique verification code that can be used to validate your achievement on our platform.</p>
            </div>
          </div>
        </div>

        <hr className="my-8 border-gray-200" />

        <h2 className="text-2xl font-semibold text-[rgb(130,88,18)] mb-4">
          Content Attribution
        </h2>
        <div className="space-y-4">
          <div className="flex items-start space-x-4">
            <div className="text-[rgb(130,88,18)]">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <div>
              <h3 className="font-semibold text-lg">Open Educational Resources</h3>
              <p className="text-gray-600">Our video lessons are sourced from publicly available YouTube channels under Creative Commons or standard licenses. We respect and acknowledge all original content creators.</p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <div className="text-[rgb(130,88,18)]">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
              </svg>
            </div>
            <div>
              <h3 className="font-semibold text-lg">Enhanced Learning Experience</h3>
              <p className="text-gray-600">Intellectual Oasis Fellowship organizes these resources into thematic modules, adding interactive quizzes, evaluations, and community interaction to create a comprehensive learning experience.</p>
            </div>
          </div>
        </div>

        <div className="mt-8 p-4 bg-blue-50 rounded-lg">
          <p className="text-gray-700">
            Need help? Our support team is always ready to assist you with any questions or concerns about your learning journey.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CourseIntroduction; 